/** Per-device preference for the Materials catalog view (List | Thumbnail). */
export const MATERIALS_VIEW_KEY = "cp_materials_catalog_view";
export const MATERIALS_VIEW = Object.freeze({ LIST: "list", THUMBNAIL: "thumbnail" });

export function readMaterialsViewPreference() {
  try {
    const value = window.localStorage.getItem(MATERIALS_VIEW_KEY);
    return value === MATERIALS_VIEW.THUMBNAIL ? MATERIALS_VIEW.THUMBNAIL : MATERIALS_VIEW.LIST;
  } catch {
    return MATERIALS_VIEW.LIST;
  }
}

export function writeMaterialsViewPreference(view) {
  try {
    window.localStorage.setItem(MATERIALS_VIEW_KEY, view);
  } catch {
    // Preference is a convenience; the view still changes for this session.
  }
}
